<div #slickContainerDivRef id="slick-container_{{uuid}}" class="slick-container" [ngClass]="{ 'slick-container-padding': padding === true }" [style.minHeight]="maxHeight" [style.maxHeight]="maxHeight">
	<ng-content select="slick-container-header"></ng-content>
	<ng-content select="slick-container-body"></ng-content>
	<ng-content select="slick-container-footer"></ng-content>
</div>

